module.exports = __webpack_public_path__ + "static/media/csv.0a2a8254.svg";